import * as propertyPictureActions from '../actions/property-picture';
import { IGalleryItem } from '../../common/models/gallery-item';
import { ActionResult } from '../models/action-result';

export interface State {
  propertyImages: IGalleryItem[];
  loading: boolean;
  actionResult: ActionResult;
}

export const INITIAL_STATE: State = {
  propertyImages: undefined,
  loading: false,
  actionResult: null
};


export function reducer(state: State = INITIAL_STATE, action: propertyPictureActions.Actions): State {
  switch (action.type) {
    case propertyPictureActions.LOAD:
    case propertyPictureActions.DELETE:
      {
        return {
          ...state,
          loading: true,
          propertyImages: undefined,
          actionResult: null,
        };
      }
    case propertyPictureActions.LOAD_COMPLETE:
      {
        return {
          ...state,
          loading: false,
          propertyImages: action.payload,
          actionResult: null
        };
      }
    case propertyPictureActions.LOAD_ERROR:
      {
        let errorMessage = 'An error occurred whilst loading pictures';
        if (action.payload.hasOwnProperty('message')) {
          errorMessage = action.payload.message;
        }
        return {
          ...state,
          loading: false,
          propertyImages: undefined,
          actionResult: new ActionResult({ success: false, message: errorMessage })
        };
      }
    case propertyPictureActions.UPLOAD_COMPLETE:
      {
        return {
          ...state,
          actionResult: new ActionResult({ success: true, message: `${action.files.length} File(s) added successfully` })
        };
      }
    case propertyPictureActions.DELETE_COMPLETE:
      {
        return {
          ...state,
          loading: false,
          actionResult: new ActionResult({ success: true, message: `${action.fileName} deleted` })
        };
      }
    case propertyPictureActions.DELETE_ERROR:
      {
        return {
          ...state,
          actionResult: new ActionResult({ success: false, message: `Failed to delete ${action.fileName}` })
        };
      }
    default:
      {
        return state;
      }
  }

}
